import React, { useMemo } from 'react'
import AsyncDropdown, { PropsWithAsyncDropdown } from 'core/elements/dropdown/AsyncDropdown'

interface Props {
  actions: string[]
}

export default function ActionPicklist({
  name = 'action',
  label = 'Action',
  compact = false,
  actions = [],
  ...rest
}: PropsWithAsyncDropdown<Props>) {
  const options = useMemo(() => {
    return actions.map((action) => ({
      label: action,
      value: action,
    }))
  }, [actions])

  return <AsyncDropdown compact={compact} name={name} label={label} items={options} {...rest} />
}
